"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.easing = void 0;
const foundation_1 = require("../foundation");
exports.easing = {
    productive: {
        linear: {
            ids_easing_productive_linear: foundation_1.foundation_ease.linear.linear,
        },
        in: {
            ids_easing_productive_accelerate_standard: foundation_1.foundation_ease.in.ease_in,
            ids_easing_productive_accelerate_01: foundation_1.foundation_ease.in.ease_in_circ,
            ids_easing_productive_accelerate_02: foundation_1.foundation_ease.in.ease_in_sine,
        },
        out: {
            ids_easing_productive_decelerate_standard: foundation_1.foundation_ease.out.ease_out,
            ids_easing_productive_decelerate_01: foundation_1.foundation_ease.out.ease_out_quad,
            ids_easing_productive_decelerate_02: foundation_1.foundation_ease.out.ease_out_sine,
        },
        inOut: {
            ids_easing_productive_standard: foundation_1.foundation_ease.inOut.ease_inOut_quad,
        },
    },
    expressive: {
        in: {
            ids_easing_expressive_accelerate: foundation_1.foundation_ease.in.ease_in_quint,
            ids_easing_expressive_accelerate_back: foundation_1.foundation_ease.in.ease_in_back,
        },
        out: {
            ids_easing_expressive_decelerate: foundation_1.foundation_ease.out.ease_out_quint,
            ids_easing_expressive_decelerate_back: foundation_1.foundation_ease.out.ease_out_back,
        },
        inOut: {
            ids_easing_expressive_standard: foundation_1.foundation_ease.inOut.ease_inOut,
            ids_easing_expressive_standard_back: foundation_1.foundation_ease.inOut.ease_inOut_back,
        },
    }
};
//# sourceMappingURL=easing.js.map